import React, { useRef, useEffect, useCallback } from 'react';
import { useMessageAdded } from "../../../../hooks/useConversations";
import InboxTypes from "../../../utils/enums/inboxTypes.enum";
import moment from 'moment';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MappedConversation(_ref) {
  let {
    conversation,
    currentEmployeeId,
    twilioClient,
    inboxType
  } = _ref;
  const isArchived = inboxType === InboxTypes.ARCHIVE;
  const messageList = useMessageAdded(conversation === null || conversation === void 0 ? void 0 : conversation.sid, conversation === null || conversation === void 0 ? void 0 : conversation.messagesByDate);
  const bottomRef = useRef(null);
  const recipient = conversation.participants.find(employee => employee.id !== currentEmployeeId);
  const [lastReadMessageIndexByReceipient, setLastReadMessageIndexByReceipient] = useState(recipient.lastReadMessageIndex);
  const scrollToBottom = useCallback(() => {
    var _bottomRef$current;
    (_bottomRef$current = bottomRef.current) === null || _bottomRef$current === void 0 || _bottomRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  }, [bottomRef]);
  useEffect(() => {
    if (messageList && currentEmployeeId) {
      const keys = Object.keys(messageList);
      if (keys.length) {
        const lastKey = keys[keys.length - 1];
        const messagesFromDate = messageList[lastKey];
        if (messagesFromDate[messagesFromDate.length - 1].author === currentEmployeeId) {
          scrollToBottom();
        }
      }
    }
  }, [messageList, scrollToBottom, currentEmployeeId]);
  useEffect(() => {
    scrollToBottom();
  });
  useEffect(() => {
    if (twilioClient) {
      twilioClient.on("participantUpdated", args => {
        var _args$participant;
        if ((args === null || args === void 0 || (_args$participant = args.participant) === null || _args$participant === void 0 ? void 0 : _args$participant.identity) !== currentEmployeeId) {
          setLastReadMessageIndexByReceipient(args.participant.lastReadMessageIndex);
        }
      });
    }
  }, [twilioClient, currentEmployeeId]);
  return /*#__PURE__*/_jsx("div", {
    id: "mappedoutconversation",
    className: "w-full flex flex-col justify-between items-stretch",
    style: {
      height: '65%'
    },
    children: /*#__PURE__*/_jsx("div", {
      className: "h-full mb-1 pr-2 flex items-stretch flex-col justify-start overflow-y-scroll hide-scrollbar",
      children: Object.keys(messageList).map((shortDate, i) => {
        const date = moment.utc(shortDate).format("MMMM D, YYYY");
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-center text-mc-gray h-2 my-4 text-xs",
            children: date
          }, date), messageList[shortDate].map((message, key) => /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col mb-4 ".concat(message.author === currentEmployeeId ? 'items-end' : 'items-start'),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex ".concat(message.author === currentEmployeeId ? 'flex-row-reverse' : 'flex-row', " mb-1"),
              children: [/*#__PURE__*/_jsx("div", {
                className: "inline-block ".concat(isArchived ? ' bg-mc-gray ' : message.author === currentEmployeeId ? 'bg-current-blue' : 'bg-med-pale-blue', " p-3 max-w-xs rounded-md"),
                children: /*#__PURE__*/_jsx("p", {
                  className: "whitespace-pre-line ".concat(message.author !== currentEmployeeId && !isArchived ? 'text-gray-900' : 'text-white'),
                  children: message.body
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "flex",
                children: /*#__PURE__*/_jsx("p", {
                  className: "mx-3 self-end text-mc-gray text-xs",
                  children: "".concat(message.dateCreated.getHours(), ":").concat((message.dateCreated.getMinutes() < 10 ? '0' : '') + message.dateCreated.getMinutes())
                })
              })]
            }), message.author === currentEmployeeId && /*#__PURE__*/_jsx("p", {
              className: "text-mc-gray text-xs",
              children: lastReadMessageIndexByReceipient !== null && lastReadMessageIndexByReceipient !== undefined && message.index <= lastReadMessageIndexByReceipient ? 'Read' : 'Delivered'
            })]
          }, key)), /*#__PURE__*/_jsx("div", {
            ref: bottomRef
          })]
        }, "message-".concat(shortDate, "-").concat(i));
      })
    })
  });
}
MappedConversation.defaultProps = {
  conversation: {
    messagesByDate: {}
  },
  currentEmployeeId: ''
};
export default MappedConversation;
//# sourceMappingURL=MappedConversation.js.map